import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import MainRadio from '../../MUI/MainRadio';

const ChangeVictim = ({ options, status, onChange }) => (
  <Grid container spacing={2} style={{ marginBottom: 16 }}>
    {options.map(({ value, label }) => (
      <Grid item key={label}>
        <MainRadio
          checked={value === status}
          value={value}
          onChange={({ e }) => {
            onChange(Number(e.target.value));
          }}
          labelKey={label}
        />
      </Grid>
    ))}
  </Grid>
);

ChangeVictim.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  status: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

ChangeVictim.defaultProps = {
  status: undefined,
};

export default ChangeVictim;
